import { Routes, Route, NavLink, Navigate, Link } from 'react-router-dom'
import { useAuth } from '../../hooks/useAuth'
import { PLATFORM_LOGO } from '../../utils/constants'
import { useSimpleHqAccess } from './useSimpleHqAccess'
import { HqHomeView } from './HqHomeView'
import { LeaveRequestView } from './LeaveRequestView'
import { LeaveCalendarView } from './LeaveCalendarView'
import { LeaveApprovalsView } from './LeaveApprovalsView'
import { LeavePeopleView } from './LeavePeopleView'
import { LeaveTypesView } from './LeaveTypesView'
import { MyWorkView } from './MyWorkView'
import { ProjectsView } from './ProjectsView'
import { ProjectDetailView } from './ProjectDetailView'
import { DelegatesView } from './DelegatesView'
import { HqCommandPalette } from './HqCommandPalette'
import './design/simple-hq.css'

export function SimpleHqLayout() {
  const { user, signOut } = useAuth()
  const { loading, role, isApprover, isHqAdmin } = useSimpleHqAccess()

  if (loading) {
    return (
      <div className="hq-app min-h-screen flex items-center justify-center">
        <i className="fa-solid fa-spinner fa-spin text-3xl text-[var(--hq-muted)]" aria-hidden />
        <span className="sr-only">Loading Simple HQ…</span>
      </div>
    )
  }

  return (
    <div className="hq-app">
      <div className="hq-shell">
        <header className="hq-topbar">
          <div className="flex items-center gap-3">
            <Link to="/simple-hq" className="hq-brand">
              Simple <span>HQ</span>
            </Link>
            <img src={PLATFORM_LOGO} alt="" className="h-7 w-auto opacity-80" />
            <span className="hq-badge">{role}</span>
          </div>
          <nav className="hq-nav" aria-label="Simple HQ">
            <NavLink to="/simple-hq" end>
              Home
            </NavLink>
            <NavLink to="/simple-hq/leave/request">My leave</NavLink>
            <NavLink to="/simple-hq/leave/calendar">Calendar</NavLink>
            {isApprover && <NavLink to="/simple-hq/leave/approvals">Approvals</NavLink>}
            {isHqAdmin && <NavLink to="/simple-hq/leave/people">People</NavLink>}
            {isHqAdmin && <NavLink to="/simple-hq/leave/types">Leave types</NavLink>}
            <NavLink to="/simple-hq/work">My work</NavLink>
            <NavLink to="/simple-hq/projects">Projects</NavLink>
            {isHqAdmin && <NavLink to="/simple-hq/settings/delegates">Delegates</NavLink>}
            <Link to="/early-signals">Early Signals</Link>
            <Link to="/?view=landing">Site</Link>
          </nav>
          <div className="flex items-center gap-3 text-sm">
            <span className="hq-cmdk-hint hidden md:inline">Ctrl+K</span>
            <span className="text-[var(--hq-muted)]">{user?.email?.split('@')[0]}</span>
            <button type="button" className="hq-btn" onClick={() => void signOut()}>
              Sign out
            </button>
          </div>
        </header>

        <HqCommandPalette isApprover={isApprover} isHqAdmin={isHqAdmin} />

        <Routes>
          <Route index element={<HqHomeView />} />
          <Route path="leave/request" element={<LeaveRequestView />} />
          <Route path="leave/calendar" element={<LeaveCalendarView />} />
          <Route
            path="leave/approvals"
            element={isApprover ? <LeaveApprovalsView /> : <Navigate to="/simple-hq" replace />}
          />
          <Route
            path="leave/people"
            element={isHqAdmin ? <LeavePeopleView /> : <Navigate to="/simple-hq" replace />}
          />
          <Route
            path="leave/types"
            element={isHqAdmin ? <LeaveTypesView /> : <Navigate to="/simple-hq" replace />}
          />
          <Route path="work" element={<MyWorkView />} />
          <Route path="projects" element={<ProjectsView />} />
          <Route path="projects/:projectId" element={<ProjectDetailView />} />
          <Route
            path="settings/delegates"
            element={isHqAdmin ? <DelegatesView /> : <Navigate to="/simple-hq" replace />}
          />
          <Route path="*" element={<Navigate to="/simple-hq" replace />} />
        </Routes>
      </div>
    </div>
  )
}
